export const getModalCyTag = ({ modalType, selectType }) => {
  let cyTag = `modalDialog-${modalType}`
  if (selectType) {
    cyTag += `-${selectType}`
  }
  return cyTag
}
